'use client'

import { type RefObject, useEffect, useRef, useState } from 'react'

export const useBoundingClientObserver = <T extends HTMLDivElement>(
  callbackIfIntersecting: () => void,
  scrollRef?: RefObject<HTMLElement>,
) => {
  const [data, setData] = useState<{ left: number; top: number }>()
  const ref = useRef<T>(null)

  useEffect(() => {
    const element = ref?.current
    if (!element || !scrollRef?.current) {
      return
    }

    const position = () => {
      const data = element?.getBoundingClientRect()
      setData({
        left: data.left,
        top: data.top,
      })
    }

    const observer = new IntersectionObserver(entries => {
      if (!entries?.[0].isIntersecting && callbackIfIntersecting) {
        callbackIfIntersecting?.()
      }
    })

    if (!data) {
      position()
    }

    observer.observe(element)

    scrollRef?.current?.addEventListener('scroll', position)

    return () => {
      // Cleanup
      scrollRef?.current?.removeEventListener('scroll', position)
    }
  }, [ref, scrollRef])

  return { data, ref }
}
